
import Marionette from "../../shared/marionette-mustache";
import {autoinject, Container} from "aurelia-dependency-injection";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import {AppEvents} from "../../app-events";
import { prop } from "../../decorators/property";
import {ImportModel} from "../models/Import";
import {IRequestOptions} from "../../search/interfaces/request-options";

@autoinject
export class ReportStatusModel extends Backbone.AssociatedModel {

    @prop() public Source: string;
    @prop() public FilesOutstanding: number;
    @prop() public LatestFileAdded: string;

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/import-status/models/report-status.ts